import React, { useState } from 'react'
import Content from 'blocks.app/content/content'
import CustomList from 'blocks.app/customList/customList'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import {
    PITAMIX_CATALOG_CONFIG,
    PITAMIX_CATALOG_TITLE_KEY,
    PitamixSelectedItems,
} from './InstancesCatalogPitamix-types'

const InstancesCatalogPitamixComponent = () => {
    const [selectedItems, setSelectedItems] = useState<PitamixSelectedItems>([])

    return (
        <Content title={PITAMIX_CATALOG_TITLE_KEY}>
            <CustomList
                type={PITAMIX_CATALOG_CONFIG.type}
                onSelect={setSelectedItems}
                selectedItems={selectedItems}
                isWebAppTitle={PITAMIX_CATALOG_CONFIG.isWebAppTitle}
                additionalData={PITAMIX_CATALOG_CONFIG.additionalData}
            />
        </Content>
    )
}

export const InstancesCatalogPitamix = checkAvailableModule('instancesCatalog/pitamix')
    ? InstancesCatalogPitamixComponent
    : null
